import AboutActive from 'components/Common/Icons/AboutActive/AboutActive';
import AboutMinerId from 'components/Common/Icons/AboutMinerId/AboutMinerId';
import GithubIcon from 'components/Common/Icons/GithubIcon/GithubIcon';
import TwitterIcon from 'components/Common/Icons/TwitterIcon/TwitterIcon';
import AboutVerified from 'components/Common/Icons/AboutVerified/AboutVerified';
import AboutStoragePower from 'components/Common/Icons/AboutStoragePower/AboutStoragePower';
import AboutDeals from 'components/Common/Icons/AboutDeals/AboutDeals';
import AboutLocation from 'components/Common/Icons/AboutLocation/AboutLocation';
import AboutRating from 'components/Common/Icons/AboutRating/AboutRating';
import { ROUTES } from './routes';

export const EMAIL_REGEX = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
);
export const IMAGE_URL_REGEX = new RegExp(/(https?:\/\/.*\.(?:png|jpg|jpeg|svg|gif))/i);
export const URL_REGEX = new RegExp(
  '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  'i',
);
export const DAYS_PER_MONTH = 30.436875;

export const API_PATH = `${process.env.SERVER_URL}/api/v1`;

export const IPFS_GATEWAY = 'https://ipfs.io/ipfs/';

export const INFO_DATA_TYPES = {
  CID_LINK: 'cid-link',
  SIZE: 'size',
  STRING: 'string',
  PRICE: 'price',
  DEAL_STATUS: 'deal-status',
  EPOCH: 'EPOCH',
};

type DealSubStatuses = { [key: number]: { label: string; className: string } };

type DealStatus = {
  label: string;
  className: string;
  canLeaveReview: boolean;
  canRetry?: boolean;
  subStatuses?: DealSubStatuses;
};

export const DEAL_STATUSES: { [key: number]: DealStatus } = {
  0: {
    label: 'Ongoing',
    className: 'ongoing',
    canLeaveReview: false,
    subStatuses: {
      0: { label: 'Sub status 1', className: 'sub-status-1' },
      1: { label: 'Sub status 2', className: 'sub-status-2' },
    },
  },
  1: { label: 'Active on chain', className: 'active', canLeaveReview: false },
  2: { label: 'Failed', className: 'failed', canLeaveReview: true, canRetry: true },
  3: { label: 'Completed', className: 'completed', canLeaveReview: true },
};

export const STORAGE_PROVIDER_DETAILS_INFO_TYPES = {
  ADDRESS: 'ADDRESS',
  REVIEW: 'REVIEW',
  REVIEW_FIVE_STARS: 'REVIEW_FIVE_STARS',
};

export const FOOTER_LINKS = [
  {
    label: 'privacyPolicy',
    url: ROUTES.PRIVACY_POLICY,
  },
  {
    label: 'termsAndConditions',
    url: ROUTES.TERMS_AND_CONDITIONS,
  },
];

export const FOOTER_SOCIALS = [
  {
    Icon: GithubIcon,
    alt: 'Github',
    url: 'https://github.com/filmineio/',
  },
  {
    Icon: TwitterIcon,
    alt: 'Twitter',
    url: 'https://twitter.com/FilmineNetwork',
  },
];

export const FOOTER_FILMINE_COPYRIGHT = '© Filmine 2022.';
export const FOOTER_FILSTATION_COPYRIGHT = '© Filstation 2022.';

export const ERROR_KEYS = {
  REQUIRED: 'required',
  INVALID_URL: 'invalidUrl',
  INVALID_EMAIL: 'invalidEmail',
  INCORRECT_ADDRESS_FORMAT: 'incorrectAddressFormat',
  ADDRESS_IS_TOO_SHORT_TO_VALIDATE: 'AddressIsTooShortToValidate',
  NOT_NUMERIC: 'notNumeric',
};

export const FILE_COIN_EXPLORER_URL = 'https://filfox.info/en/message/';

export const META_IMAGE_LINK_FILMINE = 'http://188.166.29.109/emailcontent/metare.jpg';
export const META_IMAGE_LINK_FILGRAM = 'http://188.166.29.109/emailcontent/kjfghidf.jpg';

export const MENU_ITEMS = [
  {
    label: 'explore',
    url: ROUTES.EXPLORE,
  },
  {
    label: 'home',
    url: ROUTES.HOME,
  },
  {
    label: 'howTo',
    url: ROUTES.DASHBOARD.HOW_TO.STORE,
  },
  {
    label: 'faq',
    url: ROUTES.FAQ,
  },
];

export const FAQ = [
  {
    question: 'question1',
    answer: 'answer1',
  },
  {
    question: 'question2',
    answer: 'answer2',
  },
  {
    question: 'question3',
    answer: 'answer3',
  },
  {
    question: 'question4',
    answer: 'answer4',
  },
  {
    question: 'question5',
    answer: 'answer5',
  },
  {
    question: 'question6',
    answer: 'answer6',
  },
  {
    question: 'question7',
    answer: 'answer7',
  },
  {
    question: 'question8',
    answer: 'answer8',
  },
];

export const ABOUT_PAGE_STORAGE_PROVIDER_ATTRIBUTES = [
  {
    title: 'minerId',
    description: 'storageProviderCanOwn',
    icon: AboutMinerId,
  },
  {
    title: 'active',
    description: 'minersInTheFilecoinNetwork',
    icon: AboutActive,
  },
  {
    title: 'verified',
    description: 'minersThatClaimed',
    icon: AboutVerified,
  },
  {
    title: 'storagePower',
    description: 'theTotalAmountOfSpace',
    icon: AboutStoragePower,
  },
  {
    title: 'deals',
    description: 'numberOfStorageDeals',
    icon: AboutDeals,
  },
  {
    title: 'location',
    description: 'geographicalLocation',
    icon: AboutLocation,
  },
  {
    title: 'rating',
    description: 'ratingByPreviousCustomers',
    icon: AboutRating,
  },
];

export const EXPLORE_MENU_ITEMS = [
  {
    label: 'home',
    url: ROUTES.HOME,
  },
  {
    label: 'explore',
    url: ROUTES.EXPLORE,
  },
  {
    label: 'faq',
    url: ROUTES.FAQ,
  },
];
